import { Component } from '@angular/core';

@Component({
  selector: 'hs-button-loader',
  templateUrl: './button-loader.component.html',
  styleUrls: ['./button-loader.component.scss']
})
export class ButtonLoaderComponent {

}
